import { Link, useNavigate } from "react-router-dom";

const PlanCardBenefits: React.FC<any> = () => {

  const urlBase = process.env.REACT_APP_BACKEND_API_URL;
  const navigate = useNavigate();

  const benefits : any = [
    'Dicas',
    'Eventos',
    'Classificados',
    'Radar Solidário',
    'Descontos Exclusivos',
    'Radar Viagens',
    'Businnes Networking',
  ];


  return (
    <div className="hidden md:block rounded-3xl shadow bg-[#262626]">
      <div className="flex rounded-t-3xl bg-primary-700 justify-center items-center text-center h-24 uppercase text-white font-bold text-2xl">
        PLANOS 
      </div>
      <div className="h-[120px]"></div>

      <div className="text-white px-2">
        {
          benefits.map((benefit: string, index: number) => {
            return (
              <>
                <div className="h-10 flex items-center border-b border-gray-500">
                  <div className="flex items-center justify-center rounded-full bg-white h-1 w-1 ms-1 me-4"></div>
                  <div className="text-sm">{benefit ?? '-'}</div>
                </div>
              </>
            )
        })}
      </div>

      <div className="rounded-b-3xl h-24"></div>
    </div>
  );
};

export default PlanCardBenefits;
